var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"d-none"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v(" © 2021 Duckist. All rights reserved. ")])])])])
}]

export { render, staticRenderFns }